import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import WaitlistForm from '../WaitlistForm/WaitlistForm';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showWaitlist, setShowWaitlist] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src="/images/logo.png" alt="XLR8 AI Logo" className="logo-image" />
        </Link>
        <button className="mobile-menu-button" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'}
        </button>
        <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          {/* Comment out the original waitlist button */}
          {/* <button 
            onClick={() => { 
              setShowWaitlist(true); 
              closeMenu(); 
            }} 
            className="nav-cta-button"
          >
            Request Early Access
          </button> */}
          
          {/* Add new Calendly button */}
          <a 
            href="https://calendly.com/ishgun-tryxlr8/30min" 
            target="_blank" 
            rel="noopener noreferrer"
            className="nav-cta-button"
            onClick={closeMenu}
          >
            Book a Demo
          </a>
        </nav>
      </div>

      {/* Keep the waitlist form component for future reference */}
      {showWaitlist && (
        <WaitlistForm onClose={() => setShowWaitlist(false)} />
      )}
    </header>
  );
}

export default Header; 